import { Check } from "lucide-react";
import { useLanguage } from "../i18n/LanguageContext";
import { SEOHead } from "../components/SEOHead";
import { PageHeader } from "../components/PageHeader";
import { RoomCard } from "../components/RoomCard";
import { roomCategories } from "../config/rooms";
import { Reveal, Stagger, StaggerItem } from "../components/Reveal";
import { PriceCTA } from "../components/home/PriceCTA";

export default function Rooms() {
  const { t } = useLanguage();
  return (
    <main data-testid="rooms-page">
      <SEOHead title={t.meta.rooms.title} description={t.meta.rooms.description} />
      <PageHeader eyebrow={t.roomsPage.eyebrow} title={t.roomsPage.title} text={t.roomsPage.text} crumb={t.nav.rooms} testId="rooms-header" />

      <section className="container-x">
        <Stagger className="grid gap-4 sm:grid-cols-2 lg:grid-cols-4">
          {t.roomsPage.facts.map((f) => (
            <StaggerItem key={f.label} className="rounded-3xl bg-sand-50 p-6">
              <p className="text-xs font-semibold uppercase tracking-[0.18em] text-charcoal-400">{f.label}</p>
              <p className="mt-2 font-display text-2xl" data-testid={`rooms-fact-${f.label.replace(/\s+/g, "-").toLowerCase()}`}>{f.value}</p>
            </StaggerItem>
          ))}
        </Stagger>
      </section>

      <section className="container-x section">
        <Stagger className="grid gap-6 md:grid-cols-2">
          {roomCategories.map((room, i) => (
            <StaggerItem key={room.id}><RoomCard room={room} index={i} detailed /></StaggerItem>
          ))}
        </Stagger>
      </section>

      <section className="container-x section !pt-0">
        <Reveal className="card grid gap-8 p-8 md:grid-cols-12 md:p-12">
          <h2 className="h3 md:col-span-4">{t.roomsPage.noteTitle}</h2>
          <ul className="grid gap-3 md:col-span-8" data-testid="rooms-notes">
            {t.roomsPage.notes.map((n) => (
              <li key={n} className="flex items-start gap-3 text-charcoal-700"><Check className="mt-1 h-4 w-4 shrink-0 text-clay" aria-hidden />{n}</li>
            ))}
          </ul>
        </Reveal>
      </section>

      <PriceCTA />
    </main>
  );
}
